import './leaderboard-filters.scss';

import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import type { LeaderboardPeriod } from '@/entities/leaderboard';

type LeaderboardFiltersProps = {
  active: LeaderboardPeriod;
  onChange: (value: LeaderboardPeriod) => void;
};

function LeaderboardFiltersComponent({ active, onChange }: LeaderboardFiltersProps) {
  const { t } = useTranslation();

  const PERIODS: { value: LeaderboardPeriod; label: string }[] = [
    { value: 'all_time', label: t('leaderboard.periodAllTime') },
    { value: 'daily', label: t('leaderboard.periodDaily') },
    { value: 'weekly', label: t('leaderboard.periodWeekly') },
    { value: 'monthly', label: t('leaderboard.periodMonthly') },
  ];

  return (
    <div className="leaderboard-filters">
      {PERIODS.map(({ value, label }) => (
        <button
          key={value}
          className={`leaderboard-filters__btn${active === value ? ' leaderboard-filters__btn--active' : ''}`}
          onClick={() => onChange(value)}>
          {label}
        </button>
      ))}
    </div>
  );
}

export const LeaderboardFilters = memo(LeaderboardFiltersComponent);
